import { Box, Button, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import React from 'react'
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';

const ConfirmModalContainer = ({ handleClose, handleLogOut, handleDelete, confirmData }) => {
    return (
        <Box className='d-flex align-items-center flex-start confirm-modal-container' flexDirection={"column"}>
            <DialogTitle className='d-flex align-items-center justify-content-between' sx={{ width: '100%', padding: '0px', }}>
                <Typography variant='h6'>Confirm Action</Typography>
                <Box>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        className="close-icon"
                        sx={{
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon className='close-mui-icon' />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ my: 2, width: '100%' }}>
                <Typography variant='body1'>
                   {confirmData == 'log-out' ? "Are you sure, you want to Sign Out?" : "Are you sure, you want to delete this ?"}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ width: '100%', padding: '8px 0px !important' }}>
                <Box className='d-flex align-items-center confirm-action-container' gap={2}>
                    <Button
                        className='confirm-cancel-button'
                        onClick={handleClose}
                        // sx={{ background: theme.palette.lightgray.main }}
                    >
                        Cancel
                    </Button>
                    {confirmData == "log-out" ?
                        <Button className='confirm-red-button'
                            onClick={handleLogOut}
                        >
                            Logout
                        </Button> :
                        <Button className='confirm-red-button'
                            onClick={() => handleDelete(confirmData.id)}
                        >
                            Delete
                        </Button>
                    }
                </Box>
            </DialogActions>
        </Box>
    )
}

export default ConfirmModalContainer
